export default __webpack_public_path__ + "static/media/JS.ca893abf.png";